
import { post } from '../utils/http'

export const login = (email, password) => {
  let form = new FormData();
  form.append('email', email);
  form.append('password', password);

  return post('LOGIN', '/admin/login', form);
};

export const logout = () => ({type: 'LOGOUT'})



// WEBPACK FOOTER //
// ./src/login/loginActions.js